import clsx from 'clsx';
import React, { useEffect, useRef } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import MagicUploadIcon from '../../../../../../../../assets/Svg/MagicuploadIcon';
import SearchIcon from '../../../../../../../../assets/Svg/SearchIcon';
import { ASK_AICA_SURFACE, useAskAicaSurface } from '../../context/AskAicaSurfaceContext';

import styles from './ReasoningPanel.module.scss';

const ReasoningPanel: React.FC = () => {
    const reasoningStepsRef = useRef<HTMLDivElement>(null);

    const { reasoning, isLoading, surface } = useAskAicaSurface();

    const getTypeIcon = (type: string) => {
        switch (type) {
            case 'thinking':
                return <MagicUploadIcon colour="black" width="16" height="16" />;
            case 'searching':
                return <SearchIcon style={{ color: 'black' }} />;
            case 'error':
                return <MagicUploadIcon colour="black" width="16" height="16" />;
            default:
                return <MagicUploadIcon colour="black" width="16" height="16" />;
        }
    };

    useEffect(() => {
        if (reasoningStepsRef.current) {
            reasoningStepsRef.current.scrollTop = reasoningStepsRef.current.scrollHeight;
        }
    }, [reasoning?.message]);

    const renderReasoning = () => {
        const reasoningMessage = reasoning?.message || 'Processing your question';
        return (
            <div className={styles.ReasoningStep}>
                <div className={clsx(styles.StepContent, { [styles.LoadingStepContent]: isLoading })}>
                    <div className={styles.StepHeader}>
                        <div className={styles.StepTypeIcon}>{getTypeIcon('thinking')}</div>
                    </div>
                    <div className={styles.StepDescription}>
                        <ReactMarkdown remarkPlugins={[remarkGfm]}>{reasoningMessage}</ReactMarkdown>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className={clsx(styles.ReasoningPanel, { [styles.Portfolio]: surface === ASK_AICA_SURFACE.PORTFOLIO })}>
            <div className={styles.Header}>
                <h4 className={styles.Title}>AI Reasoning Process</h4>
                <p className={styles.Subtitle}>See how AICA processes your questions</p>
            </div>

            <div className={styles.ReasoningSteps} ref={reasoningStepsRef}>
                {/* Show items if available, otherwise show a loading item with ellipsis when loading */}
                {renderReasoning()}
            </div>
        </div>
    );
};

export default ReasoningPanel;
